import React, { useState } from 'react';
import { Button } from '@mui/material';
import DocumentLevelChargeAndAllowanceModal from './DocumentLevelChargeAndAllowanceModal';
import VisibilityIcon from '@mui/icons-material/Visibility';

export default function DocumentLevelChargeAndAllowancesButton({
  control,
  readOnly = false,
  currentNetAmount = 0,
  itemBaseAmount = 0,
}) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <div>
      <Button id="adjustments" variant="contained" onClick={handleOpenModal}>
        {readOnly ? <VisibilityIcon fontSize="small" sx={{ mr: 1 }} /> : '+ '} Charges & Allowances
      </Button>

      <DocumentLevelChargeAndAllowanceModal
        open={modalOpen}
        onClose={handleCloseModal}
        control={control}
        readOnly={readOnly}
        currentNetAmount={currentNetAmount}
        itemBaseAmount={itemBaseAmount}
      />
    </div>
  );
}
